export default __webpack_public_path__ + "static/media/blur 3.fd0e8ef7.jpg";